import { makeStyles, Button, Typography } from "@material-ui/core";
import { RemoveShoppingCart, ShoppingBasket, ShoppingCart } from "@material-ui/icons";
import { localPackageCalculate } from 'pages/CustomerBookingCreate/Cart';
import { bookingState, categoriesState, isCartOpenState, packagesState, servicesState, activeServiceState, cartLoadingState, stepState, cartCachedState } from "pages/CustomerBookingCreate/state";
import React, { Suspense, useEffect, useMemo, useState } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { localizeCurrency } from "util/localizeFormat";
import { useTrackEvent } from 'util/trackEvent';
import { red } from "@material-ui/core/colors";
import { isCartValidForService, isCartValidForSubservice } from "util/availability";
import { STEP_SERVICE_DETAILS, STEP_SERVICE_PACKAGES } from "pages/CustomerBookingCreate/constants";

const useStyles = makeStyles(theme => ({
}));
const CartButton = ({
  isCartEnabled,
  ...props
}) => {
  const classes = useStyles()

  const cartCached = useRecoilValue(cartCachedState);
  const packages = useRecoilValue(packagesState);
  const services = useRecoilValue(servicesState);
  const booking = useRecoilValue(bookingState);
  const mappedCategories = useRecoilValue(categoriesState)
  const activeService = useRecoilValue(activeServiceState)
  const step = useRecoilValue(stepState)

  const [cartLoading, setCartLoading] = useRecoilState(cartLoadingState);

  const [localCalculate, setLocalCalculate] = useState(null);

  const [isOpen, setIsOpen] = useRecoilState(isCartOpenState)

  const trackEvent = useTrackEvent()

  const cartValid = useMemo(
    () => {
      if (step === STEP_SERVICE_PACKAGES) {
        const { isCartValid, markedCartServices, markedCartPackages } = isCartValidForService({
          activeService,
          categories: mappedCategories,
          cart: {
            services: services,
            packages: packages
          }
        })
  
        return isCartValid
      }
      else if (step === STEP_SERVICE_DETAILS) {
        const { isCartValid, markedCartServices, markedCartPackages } = isCartValidForSubservice({
          service: activeService,
          cart: {
            services: services,
            packages: packages
          }
        })

        return isCartValid
      }
    }, [packages, services, mappedCategories]
  );

  if (isCartEnabled && cartCached?.count > 0) {
    if (cartValid) {
      return (
        <Button
          {...props}
          disabled={cartLoading}
          variant="contained"
          fullWidth
          color="secondary"
          onClick={() => {
            trackEvent('Create Booking Cart Button Clicked')
            setIsOpen(true)
          }}
          startIcon={<ShoppingCart />}
          style={
            {
              textDecoration: "none",
            }
          }

        >Cart ({cartCached?.count}) {localizeCurrency(cartCached?.total)}</Button>
      )
    } else {
      return (
        <Button
          {...props}
          disabled={cartLoading}
          variant="contained"
          fullWidth
          color="secondary"
          onClick={() => {
            trackEvent('Create Booking Cart Button Clicked')
            setIsOpen(true)
          }}
          startIcon={<RemoveShoppingCart />}
          style={
            {
              color: red[200]
            }
          }

        >Cart has invalid items</Button>
      )
    }
  }
  return <div/>
}


export { CartButton }